import React from "react";
import { Link } from "../../raw-components/link/link";
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";
import { DepositSideMenuItemBox } from "./boxes/link/deposit/deposit-side-menu-item.box";
import { GenericSideMenuItemLabelBox } from "./boxes/link/generic/generic-side-menu-item-label.box";
import { ArrowSideMenuLinkIcon } from "./icons/arrow-side-menu-link.icon";
import { MenuItemComponentProps } from "../../../services/menu-items-common/menu-item-component-props.interface";
import {SideMenuItemContainerComponent} from "./side-menu-item-container.component";

export class DepositSideMenuItemComponent extends OrbitComponent<MenuItemComponentProps> {

    render() {

        return (
            <SideMenuItemContainerComponent  onClick={this.onClick}>
                <Link>
                    <DepositSideMenuItemBox>
                        <GenericSideMenuItemLabelBox>
                            {this.props.menuItem.text }
                        </GenericSideMenuItemLabelBox>
                        <ArrowSideMenuLinkIcon />
                    </DepositSideMenuItemBox>
                </Link>
            </SideMenuItemContainerComponent>);
    }

    onClick = async () => {
        await this.props.menuItem.execute();
    };
}
